import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    console.error(error);
  }
}

// Add to your providers in app.module.ts:
// { provide: ErrorHandler, useClass: GlobalErrorHandler },
